export default "__VITE_ASSET__DCVc0YyK__"